import React from "react";
import closeIcon from "../../assets/cross.svg";

const DeactivateStudentModal = ({ onClose, onConfirm }) => {
  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex justify-center items-center">
      <div className="w-[500px] bg-white rounded-[20px] overflow-hidden font-['Manrope']">
        {/* Header */}
        <div className="p-6 bg-gradient-to-br from-white to-blue-100 border-b border-blue-100 flex justify-between items-center">
          <h2 className="text-[18px] font-bold text-gray-900">
            Deactivate Student Account?
          </h2>
          <button onClick={onClose} className="p-1">
            <img src={closeIcon} alt="Close" className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 pb-6 pt-6 flex flex-col gap-8">
          <div className="text-[16px] leading-normal">
            <span className="text-gray-500 font-medium">
              Are you sure you want to deactivate this student's account?{" "}
            </span>
            <span className="text-gray-900 font-bold">
              This immediately suspends their access to HypeBook.
            </span>
            <br />
            <br />
            <span className="text-gray-500 font-medium">
              You can reactivate them anytime from the Inactive filter. Their data is kept.
            </span>
          </div>

          {/* Footer Buttons */}
          <div className="flex justify-end gap-2">
            <button
              onClick={onClose}
              className="h-11 px-4 py-1.5 text-[16px] font-medium text-gray-900 border border-gray-300 rounded-lg"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              className="h-11 px-4 py-1.5 text-[16px] font-medium text-white bg-red-500 rounded-lg hover:bg-red-600 transition-colors"
            >
              Deactivate
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeactivateStudentModal;
